<template>
  <div class="animated fadeIn">
    <b-row :key="iteration">
      <b-col md="2" class="tabtext font-weight-bold">
        <span style="vertical-align: middle;">Total</span>
      </b-col>
      <b-col
        class="tabtext font-weight-bold"
        :md="calculatedColumnWidth"
        v-for="st in SubTotals"
        :key="st"
        >{{ st }}</b-col
      >
      <b-col md="1" class="tabtext font-weight-bold">
        <span style="vertical-align: middle;">{{ GrandTotal }}</span>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CurrentZipRow",
  components: {},
  props: {
    current_zips_object: { type: Array },
    current_filters_object: { type: Array },
    row_width: Number,
    myIteration: Number
  },
  data() {
    return {
      current_zips: this.current_zips_object,
      current_filters: this.current_filters_object,
      calculatedColumnWidth: this.row_width,
      iteration: this.myIteration
    };
  },
  methods: {},
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    SubTotals() {
      var _total = [];
      this.current_zips.forEach(zip => {
        var _i = 0;
        zip.Filters.forEach(filter => {
          if (_total.length < _i + 1) {
            _total.push(0);
          }
          _total[_i] += parseInt(filter.Quantity);
          _i++;
        });
      });
      //_total.push(_grandTotal);
      return _total;
    },
    GrandTotal() {
      return this.SubTotals.reduce((a, b) => a + b);
    }
  },
  created() {
    //console.log(this.current_zips);
    //console.log(this.current_filters);
  },
  watch: {
    // "current_seminar.Filters.length": function() {
    // }
  },
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
